import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from '../firebase';
import { validatePassword } from "../components/helpers/validatePassword";
import CryptoJS from 'crypto-js';
import { child, get, ref } from 'firebase/database'
import { db } from '../firebase'

export const authContext = createContext();

export const useAuth = () => {
    const context = useContext(authContext);
    if (!context) throw new Error('No hay proveedor de autenticación');
    return context;
}

export function AuthProvider({ children }) {
    const initialError = {
        error: 'Ingrese a su cuenta',
        stateText: 'normal',
    }
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(initialError)

    const signup = async (userInfo) => {
        setLoading(true)
        try {
            const { isValid, error: validationError } = validatePassword(userInfo.Password, userInfo.VerificationPassword);

            if (!isValid) {
                setError({
                    error: validationError,
                    stateText: 'error',
                });
                return false;
            }
            const username = userInfo.Email.split('.com')[0].toLowerCase();

            const snapshot = await get(child(ref(db), `AllowedUsers/${username}`));

            if (snapshot.exists()) {
                const userCredential = await createUserWithEmailAndPassword(auth, userInfo.Email, userInfo.Password);
                const user = userCredential.user;
                // setError({
                //     error: 'El correo no tiene los permisos de administrador',
                //     stateText: 'error',
                // });
                return user;
            } else {
                setError({
                    error: 'El correo no tiene los permisos de administrador',
                    stateText: 'error',
                });
                return false;
            }
        } catch (errors) {
            if (errors.code === 'auth/weak-password') {
                setError({
                    error: 'La contraseña debe tener mas de 6 caracteres',
                    stateText: 'error',
                });
            } else if (errors.code === 'auth/email-already-in-use') {
                setError({
                    error: 'El correo ya se encuentra registrado',
                    stateText: 'error',
                });

            } else {
                setError({
                    error: errors.code,
                    stateText: 'error',
                });
            }
            return false;
        } finally {
            setLoading(false);
        }
    }

    const login = async (userInfo) => {
        setLoading(true)
        try {
            const respuesta = await signInWithEmailAndPassword(auth, userInfo.Email, userInfo.Password);
            createTokenWeb(userInfo.stayLoggedIn)
            const dataUser = await getDataUser(respuesta.user.email)
            setUser(dataUser)
            return respuesta;
        } catch (errors) {
            console.error(errors)
            setError({
                error: 'Datos Incorrectos, vuelva a intentar',
                stateText: 'error',
            });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const getDataUser = async (userLog) => {
        const username = userLog.split('.com')[0];
        try {
            const snapshot = await get(child(ref(db), `AllowedUsers/${username}`));
            if (snapshot.exists()) {
                return { ...snapshot.val(), email: userLog };
            } else {
                console.warn('No data available');
                return null;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }

    const logout = async () => {
        setLoading(true)
        try {
            await signOut(auth)
            setUser(null)
            setLoading(true)
            setError(initialError)
            // navigate('/')
            // window.location.reload()
        } catch (errors) {
            setError({
                error: errors.message,
                stateText: 'error',
            });
            console.error("Error LogOUT");
            console.error(errors.message);
        } finally {
            setLoading(false);
        }
    }

    const updateError = useCallback((newError) => setError(newError), []);

    const createTokenWeb = (keepSessionActive = false) => {
        let timeString = ''
        if (keepSessionActive) {
            timeString = (Date.now() + 7 * 24 * 60 * 60 * 1000).toString()
        } else {
            timeString = (Date.now() + 1 * 60 * 1000).toString()
        }
        const encrypted = CryptoJS.AES.encrypt(timeString, 'QZY6~w^L";').toString();
        localStorage.setItem('sessionExpiry', encrypted);
    }

    const checkTokenExpiry = useCallback(() => {
        const encryptedSessionExpiry = localStorage.getItem('sessionExpiry');

        try {
            const bytes = CryptoJS.AES.decrypt(encryptedSessionExpiry, 'QZY6~w^L";');
            const sessionExpiryStr = bytes.toString(CryptoJS.enc.Utf8);
            const sessionExpiry = parseInt(sessionExpiryStr, 10);
            if (isNaN(sessionExpiry)) {
                throw new Error('El valor desencriptado no es un número válido.');
            }

            if (Date.now() > sessionExpiry) {
                localStorage.removeItem('sessionExpiry');
                setError({
                    error: 'Se termino el tiempo se sesion',
                    stateText: 'error',
                });
                logout();
            }
        } catch (error) {
            logout();
        }
    }, []);

    useEffect(() => {
        const checkUser = () => {
            const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
                if (currentUser) {
                    const dataUser = await getDataUser(currentUser.email);
                    setUser(dataUser);
                    // console.log('Usuario autenticado:', dataUser);
                    setLoading(false);
                    checkTokenExpiry();
                    const intervalId = setInterval(checkTokenExpiry, 60000);
                    return () => { clearInterval(intervalId) };
                } else {
                    setUser(null);
                    setLoading(false);
                }
            });
            return () => unsubscribe();
        };

        checkUser();
    }, [checkTokenExpiry]);


    return <authContext.Provider value={{ signup, login, logout, updateError, user, loading, error }}>{children}</authContext.Provider>;
}

